<template>
    <PageLoading v-if="isLoading" />
    <div v-else class="main-wrap about-page">
        <div class="row">
            <div class="col-12">
                <q-img :src="firstImage" alt="CFMA" />
            </div>
        </div>
    </div>
</template>

<script>
import PageLoading from '@/components/PageLoading'

const loadingKeys = {
    fetchingTeam: 'fetching-team',
}

export default {
    name: 'AboutTeam',

    components: {
        PageLoading,
    },

    data() {
        return {
            team: {
                title: this.$t('team.title'),
            },
            firstImage: require('@/assets/images/organigrama_2024_08.png'),
        }
    },

    computed: {
        isLoading() {
            return this.isFetchingTeam
        },

        isFetchingTeam() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingTeam
            ).length
        },
    },
}
</script>
